import { Component, Prop, Vue } from 'vue-property-decorator';
import { MdSelect, Toggle, MdRadio, Modal } from '@/Components';
import { FormMode, GradeType, StatusExam, Languages, ProcessPhases, ProcessConfigurationTypes, Constants } from '@/Domain/enum';
import ValidationService from '@/Application/Services/ValidationService';
import ExamService from '@/Services/ExamService';
import { Exam, MultiLanguage, ProcessConfigExam } from '@/Domain/Entities';
import _ from 'lodash';
import { mapState, mapGetters } from 'vuex';
import MasterDataService from '@/Services/MasterDataService';

@Component({
    components: {
        MdSelect,
        Toggle,
        MdRadio,
        Modal
    },
    computed: {
        ...mapState('featureFlagsStore', ['multiLanguage']),
        ...mapState('languagesStore', { currentLanguage: 'current' }),
        ...mapGetters('languagesStore', { availableLanguages: 'getTranslatableLanguages' })
    }
})

export default class EditNewExam extends Vue {
    @Prop() info!: any;
    @Prop() value: any;
    @Prop() mode: any;
    @Prop() process: any;

    currentLanguage!: string;
    availableLanguages!: string[];

    FormMode = FormMode;
    GradeType = GradeType;
    StatusExam = StatusExam;
    Languages = Languages;    
    Constants = Constants;
    objectToManage = _.cloneDeep(this.info);
    submitted = false;
    tabActive: string = '';
    showModalExam: boolean = false;
    examsTypesView: any[] = [];

    $refs!: {
        newExamForm: HTMLFormElement,
        editExamForm: HTMLFormElement
    };

    get examsTypesViewFiltered() {
        return this.examsTypesView.filter(examType => examType.object.active || examType.id === this.objectToManage.examType.id);
    }

    get examsTypesViewOrdered() {
        return _.orderBy(this.examsTypesViewFiltered, [examType => _.deburr(examType.name[this.currentLanguage]).toLowerCase()]);
    }

    get requiredsProperties() {
        return this.objectToManage.creditable ? [this.objectToManage.description, this.objectToManage.creditableDescription] : [this.objectToManage.description];
    }

    get publishAndUsed() {
        return this.process.isUsed || this.process.stateToggle;
    }

    get publishAndCreditable() {
        return this.publishAndUsed && this.objectToManage.creditable;
    }

    get isPhasedNotValid() {
        return this.process.phase === ProcessPhases.enum.RANKING || this.process.phase === ProcessPhases.enum.FINISH;
    }

    save() {
        this.submitted = true;
        if (this.objectToManage.maxScore && this.objectToManage.minScore && !this.isValidScore()) {
            this.$emit('examScoreError');
            return;
        }
        if (this.objectToManage.creditable) {
            this.objectToManage.gradeType = GradeType.enum.NOSCORE ;
            this.objectToManage.isExclusive = true ;
            this.objectToManage.creditable = true ;
        }
        if (this.process.hasPercentageExams && 
            (this.$props.mode === FormMode.enum.CREATING && this.objectToManage.gradeType === GradeType.enum.SCORE && ValidationService.validateFormRequired(this.$refs.newExamForm) ||
            this.$props.mode === FormMode.enum.EDITING && this.objectToManage.gradeType !== this.info.gradeType && ValidationService.validateFormRequired(this.$refs.editExamForm))) {
                this.showModalExam = true;
                return;
        }
        if (this.$props.mode === FormMode.enum.EDITING && ValidationService.validateFormRequired(this.$refs.editExamForm)) {
            this.process.isSaving = true;
            ExamService.editExam(this.process.id, this.objectToManage.toServer())
                .then(response => {
                    const examIndex = this.process.exams.indexOf(this.info);
                    this.process.exams[examIndex] = new Exam(response);
                    this.objectToManage = {};
                    this.info.isEditing = false;
                    this.process.isSaving = false;
                    this.showModalExam = false;
                    this.$emit('editedExam');
                })
                .catch(error => {
                    this.process.isSaving = false;
                    console.log(error);
                });
        } else if (this.$props.mode === FormMode.enum.CREATING && ValidationService.validateFormRequired(this.$refs.newExamForm)) {
            this.process.isSaving = true;
            ExamService.addExam(this.process.id, new Exam(this.objectToManage).toServer())
                .then(response => {
                    this.process.exams.push(new Exam(response));
                    this.objectToManage = {};
                    this.process.isSaving = false;
                    this.showModalExam = false;
                    this.$emit('createdExam');
                })
                .catch(error => {
                    this.process.isSaving = false;
                    console.log(error);
                });
        }
    }

    saveEditNewExam() {
        this.process.hasPercentageExams = false;
        this.save();
    }

    created() {
        this.tabActive = this.currentLanguage;
        this.getProcessConfigurationExamsList();
    }

    getProcessConfigurationExamsList() {
        MasterDataService.getProcessesConfiguration(ProcessConfigurationTypes.enum.EXAMS)
        .then((response: any[]) => {
            this.examsTypesView = response.map(element => ({
                name: new MultiLanguage(element.title),
                title: new MultiLanguage(element.title),
                value: element.id,
                id: element.id,
                object: new ProcessConfigExam(element)
            }));
        }).catch(error => console.log(error));
    }

    onExamTypeChange() {
        this.objectToManage.examType = this.examsTypesView.find(examType => examType.id === this.objectToManage.examType.id).object;
    }

    cancel() {
        this.objectToManage = {};
        this.info.isEditing = false;
        this.$emit('canceledExam');
    }

    isValidScore() {
        return Number(this.objectToManage.minScore) < this.objectToManage.maxScore;
    }

}
